/* eslint-disable */
export default {
  start: 'Visita guidata rapida',
  skip: 'Ignora',
  next: 'Avanti',
  finish: 'Fine',
} as const;

// @key: @#@"start"@#@ @source: @#@"Take a quick tour"@#@
// @key: @#@"skip"@#@ @source: @#@"Skip"@#@
// @key: @#@"next"@#@ @source: @#@"Next"@#@
// @key: @#@"finish"@#@ @source: @#@"Finish"@#@
